module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "description": "Načítání nastavení"
    }
  }, [_c('v-container', {
    attrs: {
      "fluild": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('configuration-basic', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1), _vm._v(" "), (_vm.isKey && _vm.item._self) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('configuration-certificates', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56275616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Admin/Configuration.vue
// module id = 1076
// module chunks = 1